import { useSelector } from "react-redux";
import classes from './NavContainer.module.scss'
import { useEffect, useState } from "react";
import { NAME_SOUND_HOVER, useGameSounds } from "@educaplay/core";
import { TEST_SOUNDS } from "../../utils/constants";
import ButtonPrev from "../ButtonPrev";
import ButtonNext from "../ButtonNext";
import ButtonSkip from "../ButtonSkip";
import ButtonSend from "../ButtonSend";
import { motion } from "framer-motion";

export default function NavContainer() {
    const currentIndex = useSelector(state => state.game.currentIndex);
    const gameSound = useGameSounds();
    const [passFinalQuestion, setPassFinalQuestion] = useState(false);
    const questions = useSelector(state => state.game.questions);

    useEffect(() => {

        if (currentIndex === questions.length - 1) setPassFinalQuestion(true);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentIndex])


    useEffect(() => {
        gameSound.play(TEST_SOUNDS.SHOW_BUTTON);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentIndex])


    const handleHover = () => {
        gameSound.play(NAME_SOUND_HOVER);
    }

    return (
            <div className={classes.buttonsNavContainer}>
                <motion.div initial={{y: "150%"}} animate={{y: "0%"}} transition={{delay: 1.2}} className={classes.Pager}>
                    <ButtonPrev handleHover={handleHover}/>
                    <ButtonNext handleHover={handleHover} passFinalQuestion={passFinalQuestion}/>
                    <ButtonSkip handleHover={handleHover} passFinalQuestion={passFinalQuestion} />
                </motion.div>

                <ButtonSend passFinalQuestion={passFinalQuestion} />
            </div>
    );

}


